import get from 'lodash.get';

const getUserAuthorizationStatus = (rootState) => {
  const userData = get(rootState, 'user.userData', {});
  return Object.entries(userData).length !== 0 && userData.constructor === Object;
};

export default getUserAuthorizationStatus;
